



// 



import { Component } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';

import { Subject } from 'rxjs';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { ApiService } from '../../../services/api.service';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../models/user.model';
import { Group } from '../../../models/group.model';
import { FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { Product } from '../../../models/product.model';

@Component({
    selector: 'new-case',
    template: require('./new-case.component.html'),
    styles: [require('./new-case.component.css')],
})
export class NewCaseComponent {
    currentUser: User;
    caseIdError = "";
    groups: Group[];
    products: Product[];

    newCase = {
       
     } as any;

    caseId = new FormControl();

    private subject: Subject<string> = new Subject();


    constructor(private router: Router, private apiService: ApiService, private authService: AuthService,
        public dialog: MatDialog, private alertService: AlertService) {
        this.currentUser = this.authService.currentUser;

        this.getGroups();
        this.getProducts();
    }

    getGroups() {
        this.apiService.getGroups().subscribe(r => {
            this.groups = r;
        })
    }

    getProducts() {
        this.apiService.getProducts().subscribe(r => {
            this.products = r;
        })
    }

    getRowClass(row) {
        return {
            'clickable': true
        };
    }



    /** Bound to the "Create New Member" button. Unimplemented, as createCase() is. */
    createMember() {
    }

    createCase() {

        //var case = _.cloneDeep(this.newCase);
        //_.each(case.casePolicies, mp => {
        //    delete mp.formControl;
        //    mp.groupId = this.newCase.groupId;
        //})
        //console.log(case)
        //this.apiService.createCase(case).subscribe(r => {
        //    this.alertService.showMessage("Create New Case Successfully!", "", MessageSeverity.success);
        //    this.newCase = {
        //        casePolicies: [{
        //            formControl: new FormControl(),
        //            policyNumberError: ""
        //        }]
        //    } as any;
        //})
    }

    checkInvalid() {
        return this.caseId.invalid ||
            _.some(this.newCase.casePolicies, i => {
                return i.formControl.invalid || !i.productId;
            }) ||
            !this.newCase.groupId ||
            !this.newCase.firstName ||
            !this.newCase.firstName ||
            !this.newCase.zipcode ||
            !this.newCase.email 
    
    }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/components/cases-management/new-case/new-case.component.ts